import { useEventData } from "hooks/useEvent"

import { CollectionFromIframe } from "meta/pages/collection"
import PerformerListItem from "./PerformerListItem"
import EventListItemSkeleton from "../EventListItem/EventListItemSkeleton"
import { IEventData } from "meta/pages/v4/event"
import { useLocationData } from "hooks/useLocation"

interface Props {
  eventCode: string
}

interface LocationContainerProps {
  eventData: IEventData
  fromIframe?: boolean
  toggleContent?: () => void
}

const PerformerListItemContainer: React.FC<Props & CollectionFromIframe> = (props) => {
  const { eventCode, fromIframe, toggleContent } = props

  const eventData = useEventData({ idOrCodeUrl: eventCode })

  if (!eventData) {
    return <EventListItemSkeleton />
  }

  return <PerformerListItemLocationContainer
    eventData={eventData}
    fromIframe={fromIframe}
    toggleContent={toggleContent} />
}


const PerformerListItemLocationContainer: React.FC<LocationContainerProps> = (props) => {
  const { fromIframe, toggleContent, eventData } = props

  const locationData = useLocationData({ idOrCodeUrl: String(eventData.locationId) })

  if (!locationData) {
    return <EventListItemSkeleton />
  }

  return <PerformerListItem
    eventData={eventData}
    locationData={locationData}
    fromIframe={fromIframe}
    toggleContent={toggleContent} />
}

export default PerformerListItemContainer